var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3194 0.25H2.68058C1.34154 0.25 0.25 1.34154 0.25 2.68058C0.25 3.32788 0.503846 3.93712 0.960769 4.40038L5.96154 9.40115V15.2206C5.96162 15.5235 6.05161 15.8195 6.22009 16.0713C6.38858 16.323 6.62799 16.519 6.90799 16.6345C7.18799 16.7501 7.49598 16.7799 7.79295 16.7202C8.08992 16.6606 8.3625 16.5141 8.57615 16.2994L10.48 14.3956C10.8417 14.0338 11.0385 13.5579 11.0385 13.0502V9.39481L16.0392 4.39404C16.4962 3.93711 16.75 3.32788 16.75 2.68058C16.75 1.34154 15.6585 0.25 14.3194 0.25ZM15.1381 3.49923L10.1437 8.5C9.9025 8.74115 9.76923 9.05846 9.76923 9.40115V13.0565C9.76923 13.2215 9.69942 13.3865 9.58519 13.5071L7.68135 15.411C7.52904 15.5569 7.23077 15.43 7.23077 15.2206V9.40115C7.23077 9.06481 7.0975 8.74115 6.85635 8.50635L1.86192 3.49923C1.64615 3.28346 1.51923 2.98519 1.51923 2.68058C1.51923 2.03962 2.03962 1.51923 2.68058 1.51923H14.3194C14.9604 1.51923 15.4808 2.03962 15.4808 2.68058C15.4808 2.98519 15.3538 3.28346 15.1381 3.49923Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.169b82e5179b2963535db857ef9fdc65.svg";
export { ForwardRef as ReactComponent };